var pad = require('./pad');

module.exports = function lrpad(str, length, padStr) {
  return pad(str, length, padStr, 'both');
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/lrpad.js
// module id = 455
// module chunks = 0